import styled from 'styled-components'
import { COLORS } from '@themes'

const margin = 40
const padding = 26

export const Style = styled.div`
  margin: ${margin}px;
  margin-top: ${margin - margin / 2}px;
  color: ${COLORS.GRAY_1};
  font-family: Poppins, Helvetica, sans-serif;
  .btn-back {
    font-weight: 600;
    font-size: 16px;
    cursor: pointer;
    width: fit-content;
    .back {
      width: 20px;
      vertical-align: sub;
      padding-right: 4px;
    }
  }

  .detail {
    background-color: ${COLORS.BLACK_1};
    height: 100%;
    border-radius: 8px;
    margin-top: 10px;
    padding-bottom: 70px;

    .head {
      color: ${COLORS.WHITE_1};
      font-weight: 600;
      font-size: 20px;
      padding: ${padding}px;
      border-bottom: 1px solid ${COLORS.BLACK_2};
      box-sizing: border-box;
    }

    .flex {
      display: flex;
    }
    .flex-1 {
      flex: 1;
    }
    .flex-2 {
      flex: 2;
    }

    .box-logo {
      flex: 1;
      gap: 10px;
      display: flex;
      flex-direction: column;
    }

    .text-size-picture {
      color: #52577a;
      font-size: 14px;
      font-weight: 400;
    }

    .marginTop {
      margin-top: 30px;
    }

    .content {
      padding: ${padding}px;
      padding-top: 30px;
      font-weight: 600;
      font-size: 14px;
      border-bottom: 1px solid ${COLORS.BLACK_2};

      .box {
        display: flex;
      }

      .data {
        color: ${COLORS.GRAY_2};
        border-radius: 4px;
        background-color: ${COLORS.BLACK_3};
        padding: 8px;
      }
      .box-img {
        width: 196px;
        height: 196px;
        border-radius: 20px;
        padding: 10px;
        border: 2px solid ${COLORS.BLACK_3};
        box-sizing: border-box;
        position: relative;
        .edit-img {
          background-color: ${COLORS.WHITE_1};
          width: 24px;
          border-radius: 50%;
          position: absolute;
          right: 0px;
          top: 0px;
          cursor: pointer;
          box-shadow: 0px 1px ${COLORS.BLACK_1};
        }
        .cancel {
          background-color: ${COLORS.WHITE_1};
          width: 24px;
          border-radius: 50%;
          position: absolute;
          right: 0px;
          bottom: 0px;
          cursor: pointer;
          box-shadow: 0px 1px ${COLORS.BLACK_1};
          text-align: center;
          color: ${COLORS.BLACK_1};
        }
        .img {
          width: 100%;
          height: 100%;
          object-fit: contain;
        }
      }

      .input-img {
        display: none;
      }

      .des-img {
        color: ${COLORS.GRAY_2};
        font-size: 12px;
      }

      .url {
        cursor: pointer;
        width: fit-content;
        line-height: 30px;
      }

      .copy {
        position: relative;
        cursor: pointer;
        color: ${COLORS.BLUE_1};
        border: 1px solid ${COLORS.BLUE_1};
        box-sizing: border-box;
        padding: 4px 10px;
        border-radius: 4px;
        font-size: 12px;
        max-height: 30px;
      }

      .text-copy {
        position: absolute;
        top: 0;
        right: 0px;
        width: 0;
        height: 0;
        opacity: 0;
      }

      .text-success {
        position: absolute;
        font-size: 10px;
        top: -30px;
        right: 0px;
        opacity: 0.5;
        color: ${COLORS.BLUE_1};
        width: max-content;
      }

      .input {
        background-color: ${COLORS.BLACK_3};
        border: none;
        border-radius: 4px;
        color: ${COLORS.GRAY_2};
        outline: none;
      }
    }

    .btn-save {
      background-color: ${COLORS.BLUE_1};
      color: ${COLORS.WHITE_1};
      border-radius: 4px;
      width: fit-content;
      padding: 8px 16px;
      font-size: 14px;
      margin: 20px;
      text-align: center;
      float: right;
      cursor: pointer;
    }

    .error {
      margin-top: 10px;
      font-size: 12px;
      font-weight: normal;
      color: ${COLORS.RED_1};
    }
  }

  @media (max-width: 800px) {
    margin: ${margin / 2}px;
    .detail {
      .content {
        .data {
          margin-top: 20px;
        }
        .box {
          display: block;
        }
      }
      .btn-save {
        width: auto;
        float: none;
      }
    }
  }

  @media (max-width: 500px) {
    .detail .content .url {
      white-space: nowrap;
      width: 240px;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
`
